/* KAZU - máquina de escribir en el hero.
   Cada vez que el carrusel muestra una diapositiva, su título y su bajada se
   escriben letra por letra y se quedan completos hasta la siguiente. No hay
   ciclo de borrar y volver a escribir: el texto en reposo siempre está entero,
   así que se puede leer con calma. Con prefers-reduced-motion no se anima nada.

   REGLA DE SEGURIDAD: el texto solo se oculta mientras el contenedor lleva la
   clase .kz-tw-activa. Si este guion se interrumpe, se cancela o nunca corre,
   la clase no está y el texto se lee entero. Un temporizador de respaldo la
   quita pase lo que pase. Nunca dejar el hero en blanco. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var VEL_TITULO = 58;    // ms por letra
  var VEL_BAJADA = 32;
  var PAUSA_ENTRE = 160;  // ms entre el final del título y el inicio de la bajada
  var CURSOR_FINAL = 650; // ms que el cursor sigue parpadeando al terminar

  var token = 0;
  var slideActivo = null;
  var respaldo = null;

  function textoDe(nodo) {
    for (var i = 0; i < nodo.childNodes.length; i++) {
      var h = nodo.childNodes[i];
      if (h.nodeType === 3 && h.nodeValue.trim()) return h;
    }
    return null;
  }

  /* ---------- título: clip-path por prefijo ---------- */
  function anchoPrefijo(t, i) {
    var r = document.createRange();
    r.setStart(t.nodo, 0);
    r.setEnd(t.nodo, i);
    var w = r.getBoundingClientRect().width;
    if (r.detach) r.detach();
    return w;
  }

  function pintarTitulo(t, i) {
    if (i >= t.n) {
      t.el.style.clipPath = '';
      return;
    }
    var w = anchoPrefijo(t, i);
    t.el.style.clipPath = 'inset(-0.25em calc(100% - ' + (w + 4) + 'px) -0.25em -0.15em)';
    t.el.style.setProperty('--kz-cursor', w + 'px');
  }

  /* ---------- bajada: spans por letra ---------- */
  function prepararBajada(h) {
    if (!h.hasAttribute('data-kz-tw')) {
      var texto = h.textContent;
      h.setAttribute('aria-label', texto);
      h.setAttribute('data-kz-tw', '');
      var frag = document.createDocumentFragment();
      for (var i = 0; i < texto.length; i++) {
        var s = document.createElement('span');
        s.className = 'kz-tw';
        s.setAttribute('aria-hidden', 'true');
        s.textContent = texto[i];
        frag.appendChild(s);
      }
      h.textContent = '';
      h.appendChild(frag);
    }
    return { el: h, letras: h.querySelectorAll('.kz-tw') };
  }

  function pintarBajada(b, i) {
    var L = b.letras;
    for (var k = 0; k < L.length; k++) {
      L[k].classList.toggle('kz-tw--on', k < i);
      L[k].classList.toggle('kz-tw--cursor', k === i - 1 && i < L.length);
    }
  }

  /* ---------- dejar una diapositiva entera y legible ---------- */
  function mostrarEntero(slide) {
    if (!slide) return;
    var linea = slide.querySelector('.jumbo-text-line');
    if (linea) {
      linea.style.clipPath = '';
      linea.classList.remove('kz-tw-activa');
    }
    var h = slide.querySelector('h1, h2, h3');
    if (h) {
      var L = h.querySelectorAll('.kz-tw');
      for (var k = 0; k < L.length; k++) {
        L[k].classList.add('kz-tw--on');
        L[k].classList.remove('kz-tw--cursor');
      }
      h.classList.remove('kz-tw-activa');
    }
  }

  /* ---------- escribir una diapositiva ---------- */
  function escribir(slide) {
    if (slide === slideActivo) return;      // ya se está escribiendo o ya se escribió
    mostrarEntero(slideActivo);             // la anterior nunca se queda a medias
    slideActivo = slide;
    var id = ++token;

    var linea = slide.querySelector('.jumbo-text-line');
    var h = slide.querySelector('h1, h2, h3');
    var nodo = linea ? textoDe(linea) : null;
    var t = nodo ? { el: linea, nodo: nodo, n: nodo.nodeValue.length } : null;
    var b = h ? prepararBajada(h) : null;

    if (!t && !b) return;

    if (t) { t.el.classList.add('kz-tw-activa'); pintarTitulo(t, 0); }
    if (b) { b.el.classList.add('kz-tw-activa'); pintarBajada(b, 0); }

    /* Respaldo: si algo interrumpe la escritura, el texto aparece completo. */
    clearTimeout(respaldo);
    var techo = 600 +
      (t ? t.n * VEL_TITULO : 0) +
      (b ? b.letras.length * VEL_BAJADA : 0) + 1500;
    respaldo = setTimeout(function () { mostrarEntero(slide); }, techo);

    var i = 0;
    function pasoTitulo() {
      if (id !== token) return;
      i++;
      pintarTitulo(t, i);
      if (i < t.n) { setTimeout(pasoTitulo, VEL_TITULO); return; }
      setTimeout(function () {
        if (id === token) t.el.classList.remove('kz-tw-activa');
      }, CURSOR_FINAL);
      setTimeout(iniciarBajada, PAUSA_ENTRE);
    }

    var j = 0;
    function pasoBajada() {
      if (id !== token) return;
      j++;
      pintarBajada(b, j);
      if (j < b.letras.length) { setTimeout(pasoBajada, VEL_BAJADA); return; }
      setTimeout(function () {
        if (id === token) b.el.classList.remove('kz-tw-activa');
      }, CURSOR_FINAL);
    }
    function iniciarBajada() {
      if (id !== token || !b) return;
      pasoBajada();
    }

    if (t) setTimeout(pasoTitulo, 120);
    else iniciarBajada();
  }

  /* ---------- enganche con el carrusel de Horizon ---------- */
  function arrancar() {
    var comp = document.querySelector('.slideshow-section slideshow-component');
    if (!comp) return;
    var slides = comp.querySelectorAll('slideshow-slide');
    if (!slides.length) return;

    slides.forEach(function (s) {
      new MutationObserver(function () {
        if (s.getAttribute('aria-hidden') === 'false') escribir(s);
        else if (s === slideActivo) { mostrarEntero(s); slideActivo = null; }
      }).observe(s, { attributes: true, attributeFilter: ['aria-hidden'] });
    });

    var activa = comp.querySelector('slideshow-slide[aria-hidden="false"]') || slides[0];
    var primera = function () { setTimeout(function () { escribir(activa); }, 300); };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(primera);
    else primera();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();
